import { Tabs, Typography, Breadcrumb, Table } from 'antd'
import { TeamOutlined, AppstoreOutlined, MedicineBoxOutlined, DollarOutlined } from '@ant-design/icons'
import type { ColumnsType } from 'antd/es/table'
import { FilialsPage, ServicesPage, BedProfilesReadOnlyPage } from '@/pages/Refs'
import { useBaseTariffs } from '@/hooks/useBaseTariffs'
import type { BaseTariff } from '@/api/refBaseTariffs'

const { Title } = Typography

const formatCurrency = (v: number) =>
  new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v)

const tariffColumns: ColumnsType<BaseTariff> = [
  { title: 'Год', dataIndex: 'year', key: 'year', width: 90, sorter: (a, b) => a.year - b.year, defaultSortOrder: 'descend' },
  { title: 'Тип помощи', dataIndex: 'care_type', key: 'care_type', width: 130, render: (ct: string) => ct === 'КС' ? 'КС (круглосут.)' : 'ДС (дневной)' },
  { title: 'Базовая ставка (руб.)', dataIndex: 'base_tariff', key: 'base_tariff', width: 180, align: 'right', render: (v: number) => <strong>{formatCurrency(v)}</strong> },
  { title: 'Регион', dataIndex: 'region_code', key: 'region_code', width: 90, render: (c: string) => c === '50' ? '50 (МО)' : c },
  { title: 'Источник', dataIndex: 'source', key: 'source', render: (t: string | null) => t || '-' },
]

function BaseTariffsReadOnly() {
  const { data, isLoading } = useBaseTariffs()
  return (
    <Table
      columns={tariffColumns}
      dataSource={data?.items || []}
      rowKey={(r) => `${r.year}_${r.care_type}`}
      loading={isLoading}
      pagination={false}
      size="small"
    />
  )
}

export default function OrgRefsPage() {
  const items = [
    {
      key: 'filials',
      label: (
        <span>
          <TeamOutlined />
          Филиалы
        </span>
      ),
      children: <FilialsPage />,
    },
    {
      key: 'services',
      label: (
        <span>
          <AppstoreOutlined />
          Службы
        </span>
      ),
      children: <ServicesPage />,
    },
    {
      key: 'bed-profiles',
      label: (
        <span>
          <MedicineBoxOutlined />
          Профили коек
        </span>
      ),
      children: <BedProfilesReadOnlyPage />,
    },
    {
      key: 'base-tariffs',
      label: (
        <span>
          <DollarOutlined />
          Базовые тарифы
        </span>
      ),
      children: <BaseTariffsReadOnly />,
    },
  ]

  return (
    <div>
      <Breadcrumb style={{ marginBottom: 16 }}>
        <Breadcrumb.Item>Оргструктура и реквизиты</Breadcrumb.Item>
        <Breadcrumb.Item>Справочники</Breadcrumb.Item>
      </Breadcrumb>

      <Title level={2}>Справочники</Title>

      <Tabs
        defaultActiveKey="filials"
        items={items}
        style={{ marginTop: 24 }}
      />
    </div>
  )
}
